export const messages = {
  IS_NOT_ADDRESS: 'Is not an address',
  VALID_ADDRESS: 'The address is valid',
  INVALID_ADDRESS: 'Invalid address',
  CHECKSUM: 'Verification code',
  CHECKSUM_IS: 'The checksum is ',
  VALID: 'valid',
  INVALID: 'invalid',
  NETWORKS: 'Other Networks',
  MATCH: 'The address verification code is valid for the following networks',
  FOR_NET: 'for the current network',
  GOTO_ADDRESS: 'go to address',
  IGNORE: 'Ignore the verification code and ',
  PA_MESSAGE: 'If you are sure that the address is correct',
  PROCEED: 'Proceed anyway'
}
